export default function () {
  // Removido esta retornando da view
  // this.getTotalAgendasActives()
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/statistics/resources/mounted.js